import { render, staticRenderFns } from "./FreightInquiry.vue?vue&type=template&id=ed216bac&scoped=true&"
import script from "./FreightInquiry.vue?vue&type=script&lang=js&"
export * from "./FreightInquiry.vue?vue&type=script&lang=js&"
import style0 from "./FreightInquiry.vue?vue&type=style&index=0&id=ed216bac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed216bac",
  null
  
)

export default component.exports